import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Box, Chip, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
var StyledSelect = styled(Select)(function (_a) {
    var theme = _a.theme;
    return ({
        minWidth: 200,
        '& .MuiSelect-multiple': {
            padding: '8px 12px',
        },
    });
});
var FilterChip = styled(Chip)(function (_a) {
    var theme = _a.theme;
    return ({
        margin: '2px',
        height: '24px',
        fontSize: '0.75rem',
    });
});
var RatePlanFilter = function (_a) {
    var ratePlans = _a.ratePlans, selectedRatePlans = _a.selectedRatePlans, onRatePlanChange = _a.onRatePlanChange, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var handleChange = function (event) {
        var value = event.target.value;
        onRatePlanChange(value);
    };
    var renderValue = function (selected) {
        if (selected.length === 0) {
            return 'All Rate Plans';
        }
        if (selected.length === 1) {
            var ratePlan = ratePlans.find(function (rp) { return rp.id === selected[0]; });
            return (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.name) || 'Unknown Rate Plan';
        }
        return "".concat(selected.length, " rate plans");
    };
    var getSelectedRatePlanNames = function () {
        return selectedRatePlans.map(function (id) {
            var ratePlan = ratePlans.find(function (rp) { return rp.id === id; });
            return (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.name) || "Rate Plan ".concat(id);
        });
    };
    // Group rate plans by room type for better organization
    var groupedRatePlans = ratePlans.reduce(function (acc, ratePlan) {
        var roomTypeName = ratePlan.room_type_name || 'Unknown Room Type';
        if (!acc[roomTypeName]) {
            acc[roomTypeName] = [];
        }
        acc[roomTypeName].push(ratePlan);
        return acc;
    }, {});
    if (loading) {
        return (_jsxs(FormControl, { fullWidth: true, disabled: true, children: [_jsx(InputLabel, { children: "Loading Rate Plans..." }), _jsx(Select, { value: [], renderValue: function () { return (_jsxs(Box, { display: "flex", alignItems: "center", gap: 1, children: [_jsx(CircularProgress, { size: 16 }), "Loading..."] })); }, children: _jsx(MenuItem, { disabled: true, children: _jsx(CircularProgress, { size: 20 }) }) })] }));
    }
    return (_jsxs(Box, { children: [_jsxs(FormControl, { fullWidth: true, disabled: disabled, children: [_jsx(InputLabel, { children: "Rates filter" }), _jsxs(Select, { multiple: true, value: selectedRatePlans, onChange: handleChange, renderValue: renderValue, sx: {
                            minWidth: 200,
                            '& .MuiSelect-multiple': {
                                padding: '8px 12px',
                            },
                        }, MenuProps: {
                            PaperProps: {
                                style: {
                                    maxHeight: 400,
                                    width: 300,
                                },
                            },
                        }, children: [_jsxs(MenuItem, { value: "", children: [_jsx(Checkbox, { checked: selectedRatePlans.length === 0, indeterminate: selectedRatePlans.length > 0 && selectedRatePlans.length < ratePlans.length, onChange: function () {
                                            if (selectedRatePlans.length === 0 || selectedRatePlans.length === ratePlans.length) {
                                                onRatePlanChange([]);
                                            }
                                            else {
                                                onRatePlanChange(ratePlans.map(function (rp) { return rp.id; }));
                                            }
                                        }, size: "small" }), _jsx(ListItemText, { primary: "All Rate Plans", primaryTypographyProps: { fontWeight: 'bold' } })] }), Object.entries(groupedRatePlans).map(function (_a) {
                                var roomTypeName = _a[0], roomRatePlans = _a[1];
                                return (_jsxs(Box, { children: [_jsx(MenuItem, { disabled: true, children: _jsx(Typography, { variant: "caption", color: "textSecondary", sx: { fontWeight: 'bold', mt: 1 }, children: roomTypeName }) }), roomRatePlans.map(function (ratePlan) { return (_jsxs(MenuItem, { value: ratePlan.id, sx: { pl: 3 }, children: [_jsx(Checkbox, { checked: selectedRatePlans.includes(ratePlan.id), size: "small", color: "secondary" }), _jsx(ListItemText, { primary: ratePlan.name, secondary: "".concat(ratePlan.rate_mode, " - Base: $").concat(ratePlan.default_rate), primaryTypographyProps: { fontSize: '0.875rem' }, secondaryTypographyProps: { fontSize: '0.75rem' } })] }, ratePlan.id)); })] }, roomTypeName));
                            }), ratePlans.length === 0 && (_jsx(MenuItem, { disabled: true, children: _jsx(ListItemText, { primary: "No rate plans available" }) }))] })] }), selectedRatePlans.length > 0 && (_jsx(Box, { sx: { mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }, children: getSelectedRatePlanNames().map(function (name, index) { return (_jsx(FilterChip, { label: name, color: "secondary", size: "small", onDelete: function () {
                        var newSelected = selectedRatePlans.filter(function (id) { return id !== selectedRatePlans[index]; });
                        onRatePlanChange(newSelected);
                    } }, selectedRatePlans[index])); }) }))] }));
};
export default RatePlanFilter;
